import * as React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { getSrc } from 'gatsby-plugin-image';

export const useSiteMetadata = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          titleSuffix
          description
          siteUrl
        }
      }
      image: file(absolutePath: { glob: "**/src/images/logo.png" }) {
        childImageSharp {
          gatsbyImageData(layout: FIXED, width: 315)
        }
      }
    }
  `);
  const image = getSrc(data.image);

  return { ...data.site.siteMetadata, image };
};

type SEOProps = {
  pageName?: string;
  description?: string;
  pathname?: string;
  children?: React.ReactNode;
};

export const SEO = (props: SEOProps) => {
  const siteMetadata = useSiteMetadata();
  const title = props.pageName
    ? `${props.pageName} - ${siteMetadata.titleSuffix}`
    : siteMetadata.titleSuffix;
  const description = props.description ?? siteMetadata.description;
  const image = `${siteMetadata.siteUrl}${siteMetadata.image}`;
  const url = `${siteMetadata.siteUrl}${props.pathname ?? ``}`;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content="A Twitter for My Sister" />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      {props.children}
    </>
  );
};
